import { NavLink } from 'react-router-dom'
import { TEXT_LINK_FOCUS_RING } from '../../../lib/a11yFocus'
import useSectionCrumb, { Crumb } from '../../../hooks/useSectionCrumb'

export type { Crumb }

type HeadingProps = {
	title?: string
	crumbs?: Crumb[]
}

// Visual weight decreases with each breadcrumb level, matching the old title/subTitle/subSubTitle sizing.
const CRUMB_STYLES = [
	'type-page-title',
	'text-xl leading-7',
	'text-base leading-7',
]
const crumbStyleFor = (index: number) => CRUMB_STYLES[Math.min(index, CRUMB_STYLES.length - 1)]

function PageHeadings({ title, crumbs }: HeadingProps) {
	const sectionCrumb = useSectionCrumb()
	// Skip the auto section crumb if the caller already supplied that exact route explicitly.
	const needsSectionCrumb = sectionCrumb && crumbs?.[0]?.route !== sectionCrumb.route
	const allCrumbs = crumbs && (needsSectionCrumb ? [sectionCrumb, ...crumbs] : crumbs)

	if (!allCrumbs) {
		return (
			<div className='flex gap-3xl items-baseline block'>
				<h1 className='type-page-title text-white flex'>{title}</h1>
			</div>
		)
	}

	return (
		<nav aria-label='Breadcrumb'>
			<ol className='flex gap-3xl items-baseline block flex-wrap'>
				{allCrumbs.map((crumb, index) => {
					const isCurrentPage = index === allCrumbs.length - 1
					return (
						<li key={`${crumb.label}-${index}`} className='flex items-baseline gap-3xl'>
							{crumb.route && !isCurrentPage ? (
								<NavLink
									to={crumb.route}
									state={crumb.routeState}
									className={`text-white hover:text-charcoal-050 ${TEXT_LINK_FOCUS_RING} ${crumbStyleFor(index)}`}
								>
									{crumb.label}
								</NavLink>
							) : (
								<span
									aria-current={isCurrentPage ? 'page' : undefined}
									className={`text-white ${crumbStyleFor(index)}`}
								>
									{crumb.label}
								</span>
							)}
						</li>
					)
				})}
			</ol>
		</nav>
	)
}
export default PageHeadings
